// extracted by mini-css-extract-plugin
export default {"form_error":"UpdatePassword_form_error__rOj8g","password_toggle":"UpdatePassword_password_toggle__itawO"};